import { supervisorApi } from "../../api/client";

/**
 * Download the supervisor conversations CSV.
 *
 * REL-010: adds error handling (no unhandled rejection) and revokes the
 * object URL after the click so the blob isn't leaked.
 * ARC-013: goes through supervisorApi.exportConversations (which uses the
 * client's `request` helper + 401-refresh contract) instead of a raw fetch
 * with a hand-rolled Authorization header.
 *
 * @param {object}   opts
 * @param {number}   [opts.days=30]
 * @param {function} [opts.onError]  called with the Error on failure
 * @param {object}   [opts.api]      injectable for testing (defaults to supervisorApi)
 */
export async function exportConversationsCsv({ days = 30, onError, api = supervisorApi } = {}) {
  let url;
  try {
    const res = await api.exportConversations(days);
    const blob = await res.blob();
    url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `conversations_${days}d.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch (err) {
    if (onError) onError(err);
    return { ok: false, error: err };
  } finally {
    // Revoke in a finally-equivalent so the URL is released whether the
    // click succeeded or a later step threw.
    if (url) URL.revokeObjectURL(url);
  }
  return { ok: true };
}
